import React from "react";

import { Icon } from "components/Icon";
import styled from "styled-components";
import m from "definedMessages";

import { Tooltip } from "rsuite";
import Whisper from "components/Whisper";
import { withTranslation } from "hoc/WithTranslation";

const TemplateWhisper = ({
    formatMessage
}) => {
    return (<Whisper
        placement="topEnd"
        trigger="hover"
        speaker={<StyledTooltip>
            {formatMessage(m.useInTemplateRandomDigit)}
        </StyledTooltip>}
        targetClassName="template-whisper-target"
    >
        <Icon icon="question-circle2" />
    </Whisper>)
};

export default withTranslation(TemplateWhisper);

const StyledTooltip = styled(Tooltip)`
    &&.rs-tooltip .rs-tooltip-inner {
        text-align: left !important;
    }
`;
